import Request from './request';

async function tree(stock_district_code) {
    return Request('get', "api/stock-districts/tree", stock_district_code ? { stock_district_code: stock_district_code } : {});
}

async function save(id,data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/stock-districts/edit?id=" + id, data);
    } else {
        return Request('post', "api/stock-districts/add" , data);
    }
}

async function del(id) {
    return Request('get', "api/stock-districts/delete/", id ? { id: id} : {});
}

export default {
    tree,
    save,
    del,
};